import { Button } from "react-bootstrap";
import { useCallback } from "react";
import { openMobileSliderPageAction } from "../../../../mobileAppCore/mobileAppActions";
import { connect } from "react-redux";
import {
    MOBILE_SLIDER_PAGES_IDS
} from "../../../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";
import { toast } from "react-toastify";
import { LiteTradeNotificationTopUpStyled } from "./styled/LiteTradeNotificationTopUpStyled";

function LiteTradeNotificationTopUp(props) {
    const {openMobileSliderPage} = props;

    const handleClick = useCallback(() => {
        toast.dismiss();
        openMobileSliderPage(MOBILE_SLIDER_PAGES_IDS.DEPOSIT);
    }, [openMobileSliderPage]);

    return <LiteTradeNotificationTopUpStyled>
        <Button variant="info" onClick={handleClick}>
            Top up
        </Button>
    </LiteTradeNotificationTopUpStyled>
}

const mapDispatchToProps = (dispatch) => ({
    openMobileSliderPage: payload => dispatch(openMobileSliderPageAction(payload)),
});

export default connect(null, mapDispatchToProps)(LiteTradeNotificationTopUp);
